import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getUserRole, roles } from '@shared/static/roles';
import { Avatar } from '@shared/ui/parts';
import BasicSelectInput from '@shared/ui/forms/inputs/BasicSelectInput';

function NewRoleItem({ item, member }) {
  const { t } = useTranslation();
  const newRole =
    member.group_role === roles.TEAM_LEAD ? roles.TEAM_MEMBER : roles.TEAM_LEAD;

  return (
    <div className="twoLinesSelect-item">
      <div className="twoLinesSelect-left">
        <Avatar team={item} />
      </div>
      <div>
        <p className="primary-text">{t(getUserRole(newRole))}</p>
        <p className="secondary-text">{member.name}</p>
      </div>
      <div className="twoLinesSelect-team">
        <p className="body-12r text-overflow">{item.name}</p>
      </div>
    </div>
  );
}

export default function MemberNewRoleView({
  label,
  name,
  control,
  error,
  member,
}) {
  const RenderNewRole = useCallback(
    ({ item }) => <NewRoleItem item={item} member={member} />,
    [member],
  );

  return (
    <BasicSelectInput
      control={control}
      name={name}
      label={label}
      error={error}
      data={member.groups}
      isRequired
      cleanable={false}
      className="twoLinesSelect"
      Render={RenderNewRole}
    />
  );
}
